import { useState, useEffect, useCallback } from 'react';
import { errorHandler } from './errorHandler';

interface IError {
  status: string;
  code: string;
  msg: string;
}

/**
 * 封裝 Loading，Error 等 UI state
 */
function useRequest<T>(
  fetch?: () => Promise<T> | undefined,
): [boolean, IError?, T?, (() => Promise<void>)?] {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [err, setErr] = useState<IError>();
  const [data, setData] = useState<T>();

  const fetchData = useCallback(async () => {
    if (fetch) {
      try {
        setIsLoading(true);
        const res = await fetch();
        setData(res);
      } catch (e: any) {
        errorHandler(e);
        setErr({
          status: e.response.status,
          ...e.response.data,
        });
      } finally {
        setIsLoading(false);
      }
    }
  }, [fetch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [isLoading, err, data, fetchData];
}

export default useRequest;
